<template>
  <div>
    <navbar-for-guest @logout="logout" />
    <div class="nuxt_container">
      <ApplicationErrorAlert />
      <slot />
    </div>
    <dev-mark />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, useNuxtApp } from '#app'
import { ElMessage } from 'element-plus'
import { apiWebNurseryGuestMePath, destroyApiWebUserSessionPath } from '~/rails/routes'
import { useMe } from '~/composables/useMe'

const { $axios, $rollbar } = useNuxtApp() as any
const router = useRouter()
const { setDemo } = useMe()

onMounted(async () => {
  try {
    const resMe = await ($axios as any).$get(apiWebNurseryGuestMePath()) as {
      demo: boolean;
    }
    setDemo(resMe.demo)
    // 10分周期でセッションの有効状態をチェックする
    // 無効(401)な場合、axiosで処理され総合管理ログインページへリダイレクトされる
    setInterval(() => {
      ($axios as any).$get(apiWebNurseryGuestMePath())
    }, 600000)
  } catch (e: any) {
    if (e.response?.status === 401) { return }

    console.error(e)
    $rollbar?.error(e)
  }
})

const logout = async (): Promise<void> => {
  const res = await $axios.delete(destroyApiWebUserSessionPath())
  if (res.status === 200) {
    router.push('/guest_login')
  } else {
    ElMessage({
      message: 'ログアウトに失敗しました',
      type: 'error'
    })
  }
}
</script>

<style lang="sass" scoped>
.nuxt_container
  padding: 0 40px 40px 40px
</style>
